import { host } from "../../host";

export const apiGetCif = host + 'supervisor/get-cifs'